import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { DiganosticEntryComponent } from '../diganostic-entry/diganostic-entry.component';
import { LkpStoresModel } from 'src/app/models/LkpStoresModel';
import { MatDialog } from '@angular/material/dialog';
import { ProgressNoteEntryComponent } from '../progress-note-entry/progress-note-entry.component';
import { ProgressNotesModel } from 'src/app/models/ProgressNotesModel';
import { ProgressNotesService } from 'src/app/services/ProgressNotesService';
import swal from 'sweetalert2';
import { CompanyModel } from 'src/app/models/CompanyModel';
import { CompanyService } from 'src/app/services/CompanyService';


@Component({
  selector: 'app-progress-note-tab',
  templateUrl: './progress-note-tab.component.html',
  styleUrls: ['./progress-note-tab.component.css']
})
export class ProgressNoteTabComponent implements OnInit {

  patientcode = '' ;
  Patientname = '';
  progdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  proglocation = '' ;
  prognotes = '' ;
  userid = '' ;
  username = '' ;
  progtime = '' ;
  wk_font = 2;
  wk_fontsize = '2ch';
  progressnoteList : ProgressNotesModel[]=[];
  proglocationtext = [];
  disablepharnacy = false;
    digdate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
   // digdate1 =formatDate('2024-12-31', 'yyyy-MM-dd', 'en');
   chkuser = '';
   editorConfigNoToolbar = {
    editable: false,
    spellcheck: true,
    showToolbar: false,  // 🚫 This hides the toolbar
    height: 'auto',
    frameElement:false,
    minHeight: '0',
    width: '850px',
    placeholder: '',
    translate: 'no',
    defaultParagraphSeparator: '',
    defaultFontName: '',

    toolbarHiddenButtons: []
  };
    constructor(public progressnote: ProgressNotesModel,private dialogref: MatDialog,
                  public storage: LocalStorageService,
                  public progressnoteService :ProgressNotesService,
                  public companyService : CompanyService) { }

    ngOnInit(): void {
      this.patientcode = this.storage.retrieve('stgPatientCode');
      this.Patientname = this.storage.retrieve('stgPatientName');
      this.progdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
      this.RetriveProgressNotes();

      if(this.storage.retrieve('stgGroup') !='2' &&this.storage.retrieve('stgGroup') !='8'){this.disablepharnacy = true}else{this.disablepharnacy = false}
    }
    ZoomIn(){
      this.wk_font  = this.wk_font  + 0.5;
      this.wk_fontsize = this.wk_font + 'ch';
    }
    ZoomOut(){
      this.wk_font  = this.wk_font  - 0.5;
      this.wk_fontsize = this.wk_font + 'ch';
    }
    RetriveProgressNotes(){
      this.progressnoteList = [];
             this.progressnoteService.getProgressNotesPatient(this.patientcode).subscribe((data: ProgressNotesModel[]) => {
                for (let i = 0; i < data.length; i++) {
                  this.progressnoteList[i] = data[i];
                  this.progressnoteList[i].progdate =formatDate(data[i].progdate, 'yyyy-MM-dd', 'en');
                 ///this.progressnoteList[i].userid = data[i].userid;
                  this.companyService.getcompany(data[i].proglocation).subscribe((data: CompanyModel) => {

                 this.proglocationtext[i] = data.compName;

                                 });
                }
              })
    }
    EditProgressNotes(item: ProgressNotesModel){
   
      this.chkuser = item.username;
 
     if( item.username == this.storage.retrieve('stgusername') || this.storage.retrieve('stgGroup') == '8')
      {
  
      if(this.storage.retrieve('stgGroup') == '8'){
        this.storage.store('stgUserIdId',item.userid);
        this.storage.store('stgUsernamename',item.username);
      }else
      {
        this.storage.store('stgUserIdId','')
        this.storage.store('stgUsernamename','');
      };


      const dialogRef = this.dialogref.open(ProgressNoteEntryComponent,
        {
          data: {
            dataKey: this.progressnote,
            patientcode : item.patientcode,
            Patientname : this.storage.retrieve('stgPatientName'),
            progdate : item.progdate,
            username : this.storage.retrieve('stgUsernamename'),
            useridid : this.storage.retrieve('stgUserIdId')
          },
          width: '50vw',
          height: '30vw',
        });
      dialogRef.afterClosed().subscribe(result => {
      this. RetriveProgressNotes();
      });

      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          this.RetriveProgressNotes();
          dialogSubmitSubscription.unsubscribe();
        });
      }
      else{
          this.MesgWarrning()
      }
    }

  EditOldRecord(item: ProgressNotesModel){
      debugger;
      this.chkuser = item.username;
      var wk_curntuser = this.storage.retrieve('stgusername');
      var wk_curntgroup = this.storage.retrieve('stgGroup');
     if( item.username != this.storage.retrieve('stgusername') && this.storage.retrieve('stgGroup') != '8'){   this.MesgWarrning();return;};  

      const dialogRef = this.dialogref.open(ProgressNoteEntryComponent,
        {
          data: {
            dataKey: this.progressnote,
            patientcode : item.patientcode,
            Patientname : this.storage.retrieve('stgPatientName'),
            progdate : item.progdate,
          
            username : item.username,
            useridid : item.userid,

            reialuserid : this.storage.retrieve('stgUserId'),
            reialusername : this.storage.retrieve('stgUsername')
          },
          width: '50vw',
          height: '30vw',
        });
        
      dialogRef.afterClosed().subscribe(result => {
      this. RetriveProgressNotes();
      });

      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          this.RetriveProgressNotes();
          dialogSubmitSubscription.unsubscribe();
        });
    
    }

      MesgWarrning(){

        swal({
          title: 'Check User',
          text:'Editing or deleting this medical record allowed only for: ' + this.chkuser,
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK',
          //cancelButtonText: 'No, keep it',
        })
        ;

      }
    DeleteProgressNote(){

        this.progressnoteService.deleteProgressNotes(this.storage.retrieve('stgVisitDate'),this.storage.retrieve('stgPatientCode'),this.userid).subscribe(
            (data: ProgressNotesModel) => {
              this.RetriveProgressNotes();
            }
          );
          this. RetriveProgressNotes();
    }
    openDialog(){
       if(this.patientcode !='0000' && this.patientcode != '' ){

      var wk_Date =formatDate(new Date(), 'yyyy-MM-dd', 'en')

        this.storage.store('stgVisitDate',wk_Date )
       
         const dialogRef = this.dialogref.open(ProgressNoteEntryComponent,
           {
             data: {
              dataKey: this.progressnote, 
              patientcode : this.patientcode,
              Patientname : this.storage.retrieve('stgPatientName'),
              progdate :wk_Date,
              useridid : this.storage.retrieve('stgUserId'),
              username :this.storage.retrieve('stgUsername')
             },
             width: '50vw',
             height: '30vw',
           });
           dialogRef.afterClosed().subscribe(result => {
           this.RetriveProgressNotes();
         });

         const dialogSubmitSubscription =
           dialogRef.componentInstance.submitClicked.subscribe(result => {
             this.RetriveProgressNotes();
             dialogSubmitSubscription.unsubscribe();
           });
          }
    }

    OpenNewRecord(){
    if(this.patientcode ==='0000' && this.patientcode.toString() === '' ) {return;};

       this.storage.store('stgVisitDate',formatDate(new Date(), 'yyyy-MM-dd', 'en'))

         const dialogRef = this.dialogref.open(ProgressNoteEntryComponent,
           {
             data: {
              dataKey: this.progressnote, 
              patientcode : this.patientcode,
              Patientname : this.storage.retrieve('stgPatientName'),
              progdate : this.storage.retrieve('stgVisitDate'),
              useridid : this.storage.retrieve('stgUserId'),
              username :this.storage.retrieve('stgUsername'),
              ////----------------------------------------------
              reialuserid : this.storage.retrieve('stgUserId'),
              reialusername : this.storage.retrieve('stgUsername')
             },
             width: '50vw',
             height: '30vw',
           });
           dialogRef.afterClosed().subscribe(result => {
           this.RetriveProgressNotes();
         });

         const dialogSubmitSubscription =
           dialogRef.componentInstance.submitClicked.subscribe(result => {
             this.RetriveProgressNotes();
             dialogSubmitSubscription.unsubscribe();
           });
          
    }
    MessegeDelete(item :ProgressNotesModel){
    this.chkuser = item.username;
    if( item.username == this.storage.retrieve('stgusername') || this.storage.retrieve('stgGroup') == '8')
      {
      swal({
        title: 'Are you sure?',
        text: 'You will not be able to recover this record!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      }).then(
        () => {
          this.storage.store('stgPatientCode',item.patientcode);
          this.storage.store('stgVisitDate',item.progdate)
          this.userid =item.userid;
          this.DeleteProgressNote();
          swal('Deleted!', 'Your record has been deleted.', 'success');
        },
        function (dismiss) {
          if (dismiss === 'cancel') {
            swal('Cancelled', 'Your record is safe :)', 'error');
          }
        }
      );
      }
      else
      { this.MesgWarrning()}
    }


  }

